<template>
    <div style="margin-bottom: var(--altura-menu-padrao);padding-bottom: var(--padding-padrao-pequeno);">

<!-- botao buscar  -->
        <button 
        :class="[classeSelecionada == 'buscar' ? 'btn-search selecionado' : 'btn-search naoselecionado-par']" @click="clicarBuscar">
            <img class="lupa" src="../../assets/icons/icon-pesquisar.png" alt="" :style="{filter:classeSelecionada == 'buscar' ?'':corImagem}">
        </button>

<!-- todas as classes de cardapio -->
        <div v-for="(item, index) in produtos" :key="index" >
            
            <button
            :class="[classeSelecionada == item.nome ? 'btn selecionado' : index % 2 == 0 ? 'btn naoselecionado-par' : 'btn naoselecionado-impar' ]" @click="clicarClasse(item.nome)">
                <img :src="item.icone" alt="" :style="{filter:classeSelecionada!== item.nome ?corImagem:''}">
                <p class="nome"> {{ item.nome }}</p>
            </button>
        </div>
    </div>
</template>

<script>
import {  mapState } from 'vuex';
/**
 * Menu lateral com todas as classes em forma de botao com o icone e o nome da classe.
 * 
 * @vue-data {Number} [produtos=$store.state.produtos] traz todos os produtos da store
 * @vue-computed {String} [classeSelecionada=state.classeSelecionada] traz do store a classe que foi selecionada
 */
export default {
    name: "MenuClasses",
    data() {
        return {
            mostrarBusca: false,
            produtos: this.$store.state.produtos,
            corImagem:this.$store.state.corTexto === "black" ? 'invert(100%)' : 'invert(0%)',
        }
    },
    computed: {
        ...mapState({
            classeSelecionada: state => state.classeSelecionada
        })
    },
    methods: {

        /**
         * Aciona o store e dispara a acao setClasseSelecionada
         * 
         * Alem de mudar a cor do botao classe, ja adiciona os itensVenda no atributo itensVenda
         * do store, mandando tanto o titulo da classe quanto os itensVenda no payload.
         * nomeDoItem é nome do tem que deve vir dos produtos no data.
         */
        clicarClasse(nomeDaClasse) {
            let obj = this.$store.state.produtos.find(o => o.nome == nomeDaClasse);
            let payload = {
                titulo: nomeDaClasse,
                observacoes: obj["observacoes"],
                descricao: obj["descricao"],
                itensVenda: obj["itensVenda"]
            }
            this.$store.dispatch('setMostrarBarraBusca', false)   
            this.$store.dispatch('setClasseSelecionada', payload)  
            // window.scrollTo(0,0) 
            window.scroll({top:0,  behavior: "smooth", })
        },

        clicarBuscar() {
            this.mostrarBusca = !this.mostrarBusca
            this.$store.dispatch('setClasseSelecionada', {titulo: "buscar"}) 
            this.$store.dispatch('setMostrarBarraBusca', null)     
        }
    },   
}
</script>

<style scoped>
.lupa{
    max-width: 4vh;
    margin-bottom: 0px;
}
.btn {
    font-size: 9px;
    padding-inline: 0px;
    padding-block: 10px;
    width: 100%;
    color: var(--cor-texto);
}

.nome {
  word-break: break-word;
}

button > img {
    max-width: 8vh;
    margin-bottom: 5px;
}

.btn-search {
    width: 100%;
    height: 54px;
}

.img-selecionado{
    filter:invert('invert(100%)');
}

.selecionado {
    background: linear-gradient(to top, var(--cor2-escura), var(--cor2-clara));   
    color: white;
    font-weight: 900;
}

.naoselecionado-par,.naoselecionado-impar {
    /* background: linear-gradient(to top, var(--cor1-escura), var(--cor1-clara));    */
    background: var(--gradiente-btn-conta);
    font-weight: 900;
}


/* desktops  */
@media only screen and (min-width: 720px) {
    .btn {
        padding-block: 20px;
        width: 15vh;
        color: white;
        min-height: 120px;
    }

    .btn-search {
        width: 100%;
    }

    .nome {
        /* font-size: 0.8rem; */
    }
}


</style>